import logo from '../styles/logo.png'; // Ensure this file exists
import { Link } from 'react-router-dom';
function Contact() {
    return (

      <div className="container">
        <h1>Contact us</h1>
        <p>Please drop an email to aiasapsolutions@gmail.com</p>
        {/* Add your content here */}
      </div>
    );
  }
  
  export default Contact;